import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import FormSection from './FormSection';

interface ProtectedSectionProps {
  children: React.ReactNode;
  sx?: any;
  message: string;
  locked?: boolean;
}

const Overlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: theme.custom?.isDark
    ? 'rgba(0, 0, 0, 0.7)'
    : 'rgba(0, 0, 0, 0.5)',
  borderRadius: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10,
}));

const MessageText = styled(Typography)(({ theme }) => ({
  color: theme.custom?.textCTA || '#FFFFFF',
  fontSize: 18,
  fontWeight: 600,
  textAlign: 'center',
  padding: '20px',
  whiteSpace: 'pre-wrap',
}));

const Container = styled(Box)({
  position: 'relative',
});

const ProtectedSection: React.FC<ProtectedSectionProps> = ({
  children,
  sx,
  message,
  locked = false,
}) => {
  return (
    <Container>
      <FormSection sx={sx}>{children}</FormSection>
      {locked && (
        <Overlay sx={{ ...sx }}>
          <MessageText>{message}</MessageText>
        </Overlay>
      )}
    </Container>
  );
};

export default ProtectedSection;
